// src/utils/inventory/dateUtils.js

export const safeNumber = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const toLocalISODate = (d) => {
  const x = new Date(d);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// Use LOCAL date for daily grouping
export const toISODate = (d) => toLocalISODate(d);

// Parse YYYY-MM-DD as LOCAL midnight
export const clampDate = (d) => {
  if (d == null) return null;

  if (d instanceof Date) {
    return Number.isNaN(d.getTime()) ? null : d;
  }

  if (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
    const dt = new Date(`${d}T00:00:00`);
    return Number.isNaN(dt.getTime()) ? null : dt;
  }

  const dt = new Date(d);
  return Number.isNaN(dt.getTime()) ? null : dt;
};

// Inclusive end-of-day (LOCAL)
export const endOfDay = (d) => {
  const dt = clampDate(d);
  if (!dt) return null;
  dt.setHours(23, 59, 59, 999);
  return dt;
};

export const startOfPeriod = (d, period) => {
  const x = new Date(d);

  if (period === "D") {
    x.setHours(0, 0, 0, 0);
    return x;
  }

  if (period === "W") {
    // Monday start
    const day = x.getDay(); // 0=Sun...6=Sat
    const diff = (day === 0 ? -6 : 1) - day; // move to Monday
    x.setDate(x.getDate() + diff);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  if (period === "M") {
    x.setDate(1);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  if (period === "Y") {
    x.setMonth(0, 1);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  x.setHours(0, 0, 0, 0);
  return x;
};

export const nextPeriodDate = (d, period) => {
  const x = new Date(d);

  if (period === "D") x.setDate(x.getDate() + 1);
  else if (period === "W") x.setDate(x.getDate() + 7);
  else if (period === "M") x.setMonth(x.getMonth() + 1, 1);
  else if (period === "Y") x.setFullYear(x.getFullYear() + 1, 0, 1);
  else x.setDate(x.getDate() + 1);

  return x;
};

export const generatePeriodKeys = (from, to, period, groupKeyByPeriod) => {
  const keys = [];
  if (!from || !to) return keys;

  let cur = startOfPeriod(from, period);
  const end = new Date(to);

  let guard = 0;
  while (cur <= end && guard < 5000) {
    keys.push(groupKeyByPeriod(cur, period));
    cur = nextPeriodDate(cur, period);
    guard += 1;
  }

  return keys;
};

export const parsePeriodToDate = (periodStr) => {
  // D: "YYYY-MM-DD"
  // M: "YYYY-MM"
  // Y: "YYYY"
  // W: "YYYY-Wxx"
  if (!periodStr) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(periodStr)) return new Date(periodStr + "T00:00:00");
  if (/^\d{4}-\d{2}$/.test(periodStr)) return new Date(periodStr + "-01T00:00:00");
  if (/^\d{4}$/.test(periodStr)) return new Date(periodStr + "-01-01T00:00:00");

  const m = periodStr.match(/^(\d{4})-W(\d{2})$/);
  if (m) {
    const year = Number(m[1]);
    const week = Number(m[2]);

    // ISO-ish week -> Monday
    const simple = new Date(Date.UTC(year, 0, 1 + (week - 1) * 7));
    const dow = simple.getUTCDay() || 7;
    if (dow <= 4) simple.setUTCDate(simple.getUTCDate() - dow + 1);
    else simple.setUTCDate(simple.getUTCDate() + 8 - dow);
    return new Date(simple);
  }

  return null;
};
